import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

// 数据分析总览

export const QueryIncomeYearAnalysis = () => {
    return api.post(`${baseApi}/dataAnalysis/board/getIncomeFinishRateSummaryNoAuthority`);
};

export const QueryIncomeMonthAnalysis = () => {
    return api.post(`${baseApi}/dataAnalysis/board/getIncomeFinishRateSummary4MonthNoAuthority`);
};

export const QueryAccumulate = data => {
    return api.post(`${baseApi}/dataAnalysis/board/getIncomeFinishRateSummary4AccumulateNoAuthority`, data);
};

export const QueryIncomeAllMonth = () => {
    return api.post(`${baseApi}/dataAnalysis/board/getIncomeSummaryNoAuthority`);
};

export const QueryIncomeAllArea = () => {
    return api.post(`${baseApi}/dataAnalysis/board/getIncomeActualSumByArea`);
};

// 操作管理

export const queryOperation = data => {
    return api.post(`${baseApi}/operation/getOperationList4CurrentUserPage`, data);
};

// 收入分析收入维度汇总数据

export const QueryIncomeDemiss = data => {
    return api.post(`${baseApi}/dataAnalysis/income/incomeActual/getIncomeActualAnalysisSummary`, data);
};

// 收入分析收入维度区域数据

export const QueryIncomeArea = data => {
    return api.post(`${baseApi}/dataAnalysis/income/incomeActual/getIncomeActualAnalysisSummaryByArea`, data);
};

// 收入分析收入维度客户数据
export const QueryIncomeCustomer = data => {
    return api.post(`${baseApi}/dataAnalysis/income/incomeActual/getIncomeActualAnalysisByCustomerPage`, data);
};

// 收入分析项目维度占比数据
export const QueryClausePrecent = data => {
    return api.post(`${baseApi}/dataAnalysis/income/medicalItem/getProportionByClassify`, data);
};

// 收入分析项目每月数据
export const QueryClauseList = data => {
    return api.post(`${baseApi}/dataAnalysis/income/medicalItem/getIncomeActualAnalysisByMedicalItemPage`, data);
};
// 收入分析中区域维度

export const QueryAnalayArea = data => {
    return api.post(`${baseApi}/dataAnalysis/income/area/getIncomeFinishRateByArea`, data);
};

// 收入分析的人员维度

export const QueryUserRegion = data => {
    return api.post(`${baseApi}/incomeTarget/getAreaOrRegionTargetMonth`, data);
};

export const QueryUserComplete = data => {
    return api.post(`${baseApi}/dataAnalysis/income/user/getIncomeGapByUser`, data);
};

export const QueryUserCustomer = () => {
    return api.post(`${baseApi}`);
};

// 收入分析预估维度

export const QueryForecastIncomeArea = data => {
    return api.post(`${baseApi}/dataAnalysis/income/forecast/getCompare2ActualByArea`, data);
};

export const QueryForecastIncomeCust = data => {
    return api.post(`${baseApi}/dataAnalysis/income/forecast/getCompare2ActualByCustomer`, data);
};

// 数据分析存量客户

export const QueryBoard = data => {
    return api.post(`${baseApi}/dataBoard/getOverview4Area`, data);
};

export const QueryAreaBoard = data => {
    return api.post(`${baseApi}/dataBoard/getTargetByParentArea`, data);
};

export const QueryUserBoard = data => {
    return api.post(`${baseApi}/dataBoard/getTargetByParentArea`, data);
};

export const QueryCustomerBoard = data => {
    return api.post(`${baseApi}/dataBoard`, data);
};

export const QueryCompanyAreaBoard = data => {
    return api.post(`${baseApi}/dataBoard/getAreaIncomeInfoByParent`, data);
};

export const QueryCompanyUserBoard = data => {
    return api.post(`${baseApi}/dataBoard/getUserIncomeInfoByArea`, data);
};

export const QueryCompanyCustomerBorad = data => {
    return api.post(`${baseApi}/dataBoard/getCustomerIncomeInfoByArea`, data);
};

// 有权限

export const QueryAuthBoard = data => {
    return api.post(`${baseApi}/dataBoard/getOverview4AreaWithAuthority`, data);
};

export const QueryAuthCompanyAreaBoard = data => {
    return api.post(`${baseApi}/dataBoard/getAreaIncomeInfoByParent`, data);
};

export const QueryAuthCompanyUserBoard = data => {
    return api.post(`${baseApi}/dataBoard/getUserIncomeInfoByArea`, data);
};

// 收入看板

export const QueryAreaIncome = data => {
    return api.post(`/board/income/getBoardIncomeAreaData`, data);
};

export const QueryUserIncome = data => {
    return api.post(`/board/income/getBoardIncomeUserData`, data);
};

export const QueryMonthIncome = data => {
    return api.post(`/board/income/getBoardIncomeAreaDataBy12Month`, data);
};

export const QueryBoardCustomer = data => {
    return api.post(`/board/customer/getBoardCustomerByField`, data);
};

export const QueryIncomeBoradCustomerUser = data => {
    return api.post(`/board/income/getBoardIncomeCustomerByUser`, data);
};

export const QueryIncomeBoradCustomerArea = data => {
    return api.post(`/board/income/getBoardIncomeCustomerByArea`, data);
};

// 预估结算对比

export const QueryForecastSettlement = data => {
    return api.post(`${baseApi}/report/forecast/getIncomeForecastCompareSettle4CustomerPage`, data);
};

export const QuerySettleDate = code => {
    return api.get(`/config/getConfigByCode/${code}`);
};

export const UpdateConfigDate = data => {
    return api.post(`/config/updateConfig`, data);
};

export const QueryUnusualList = data => {
    return api.post(`/recordUnusual/getRecordUnusual`, data);
};

export const AddUnusual = data => {
    return api.post(`/recordUnusual/addRecordUnusual`, data);
};

export const UpdateUnusual = data => {
    return api.post(`/recordUnusual/updateRecordUnusual`, data);
};

/// 营销数据

export const QueryMarketIncome = data => {
    return api.post(`/board/conduct/getBoardConductIncomeArea`, data);
};

export const QueryMarketPayment = data => {
    return api.post(``, data);
};

export const QueryMarketDevelop = data => {
    return api.post(``, data);
};

export const QueryMarketingCustomer = data => {
    return api.post(`/board/conduct/getBoardConductIncomeCustomerPage`, data);
};

export const QueryMarketingUser = data => {
    return api.post(`/board/conduct/getBoardConductIncomeUser`, data);
};

// 收入指标完成情况

export const QueryIncomeBudgetComplete = data => {
    return api.post(`/incomeActualAnalysis/getAnalysisIncomeActualFinishRate4UserPage`, data);
};

// 收入指标计算情况
export const QueryIncomeBudgetError = data => {
    return api.post(`/incomeActualAnalysis/getAnalysisIncomeActualFinishRate4User2CustomerPage`, data);
};

// 回款指标完成情况

export const QueryReturnBudgetComplete = data => {
    return api.post(``, data);
};

// 收入预估对比

export const QueryIncomeForecast = data => {
    return api.post(`/incomeActualAnalysis/getAnalysisIncomeActualForecastFinishRate4UserPage`, data);
};

export const QueryVisitCount = data => {
    return api.post(`/visit/getStaticVisitCustomerFrequencyVoListPage`, data);
};

// 同环比分析
export const QueryCompareMonth = data => {
    return api.post(`/incomeActualAnalysis/getAnalysisIncomeActualCustomerMonthOnMonthPage`, data);
};

export const QueryCompareYear = data => {
    return api.post(`/incomeActualAnalysis/getAnalysisIncomeActualCustomerYearOnYearAndMonthOnMonthPage`, data);
};

export const QueryTopData = data => {
    return api.post(`/analysis4Income/getSynthesisSummarizing`, data);
};

export const QueryBottomData = data => {
    return api.post(`/analysis4Income/getSynthesisCustomerPage`, data);
};

export const QueryBottomUserData = data => {
    return api.post(`/analysis4Income/getSynthesisUserPage`, data);
};

export const QueryOpportunityPage = data => {
    return api.post(`/customerOpportunity/getCustomerOpportunityPage`, data);
};

export const DeleteOpportunity = ({ opportunityId }) => {
    return api.get(`/customerOpportunity/deleteCusOpp/${opportunityId}`);
};

export const SaveOpportunity = data => {
    return api.post(`/customerOpportunity/addCusOpp`, data);
};

export const UpdateOpportunity = data => {
    return api.post(`/customerOpportunity/updateCusOpp`, data);
};

export const UpdateTransferFlag = ({ opportunityId, flag }) => {
    return api.get(`/customerOpportunity/updateOpportunityStageTransferToIntentiony/${opportunityId}/${flag}`);
};

export const UpdateNotTransferFlag = ({ opportunityId }) => {
    return api.get(`/customerOpportunity/updateOpportunityStageTransferToNoIntention/${opportunityId}`);
};

export const UpdateTransferCustomer = data => {
    return api.post(`/customerOpportunity/updateOpportunityStageTransferToPotentialCustomer`, data);
};

export const SubmitOpportunityFlow = data => {
    return api.post(`/workflow/customer/opportunity/save4Assess`, data);
};

export const QueryOpportunityInfo = ({ opportunityId }) => {
    return api.get(`/customerOpportunity/getCustomerOpportunityByOpportunityId/${opportunityId}`);
};

export const UpdateOpportunityFlag = ({ opportunityId, flag }) => {
    return api.get(`/customerOpportunity/updateOpportunityStageTransferToVerify/${opportunityId}/${flag}`);
};

//查询商机的联系人
export const QueryOpportunityLink = data => {
    return api.post(`/customerOpportunityEmployeeAttitude/getCustomerOpportunityEmployeeAttitudeVoList`, data);
};

export const UpdateOpportunityLink = data => {
    return api.post(`/customerOpportunityEmployeeAttitude/updateCustomerOpportunityEmployeeAttitude`, data);
};

export const DeleteOpportunityLink = ({ attitudeId }) => {
    return api.get(`/customerOpportunityEmployeeAttitude/delete/${attitudeId}`);
};

export const AddOpportunityLink = ({ opportunityId, employeeId, cliqueFlag }) => {
    return api.get(`/customerOpportunityEmployeeAttitude/add/${opportunityId}/${employeeId}/${cliqueFlag}`);
};

export const QueryOpportunityySumWeight = data => {
    return api.post(`/customerOpportunityEmployeeAttitude/getSumWeightByConditions`, data);
};

export const UpdateAllWeight = data => {
    return api.post(`/customerOpportunityEmployeeAttitude/updateWeightBatch`, data);
};

export const QueryAnalyseTarget = data => {
    return api.post(`/analysis4User/getAnalysis4SingleUserIncomeTarget`, data);
};

export const QueryAnalyseCustomer = data => {
    return api.post(`/analysis4User/getAnalysis4SingleUserCustomerNum`, data);
};

export const QueryCustomerList = data => {
    return api.post(`/analysis4User/getAnalysis4SingleUserCustomerListPage`, data);
};

export const QueryAreaDashUser = data => {
    return api.post(`/analysis4Area/getAnalysis4SingleAreaUserListPage`, data);
};

export const QueryAreaDashCust = data => {
    return api.post(`/analysis4Area/getAnalysis4SingleAreaCustomerListPage`, data);
};

export const QueryAreaCustCount = data => {
    return api.post(`/analysis4Area/getAnalysis4SingleAreaCustomerNum`, data);
};

export const QueryAreaTargetCount = data => {
    return api.post(`/analysis4Area/getAnalysis4SingleAreaIncomeTarget`, data);
};

// 首页的数据统计

export const QueryContractCount = () => {
    return api.get(`/analysis4HomePage/getAnalysis4HomePage4Cooperation`);
};

export const QueryCustomerCount = () => {
    return api.get(`/analysis4HomePage/getAnalysis4HomePage4Customer`);
};

export const QueryActionSubCount = () => {
    return api.get(`/analysis4HomePage/getAnalysis4HomePage4ActionKeypoint4ManageUser`);
};

export const QueryOppotunityCount = () => {
    return api.get(`/analysis4HomePage/getAnalysis4HomePage4Opportunity`);
};

export const QueryActionSelfCount = () => {
    return api.get(`/analysis4HomePage/getAnalysis4HomePage4ActionKeypoint`);
};

export const QueryPlanSelfCount = () => {
    return api.get(`/analysis4HomePage/getAnalysis4HomePage4ActionPlan`);
};

export const QueryPlanSubCount = () => {
    return api.get(`/analysis4HomePage/getAnalysis4HomePage4ActionPlan4ManageUser`);
};

export const QueryVisitSelfCount = () => {
    return api.get(`/analysis4HomePage/getAnalysis4HomePage4Visit`);
};

export const QueryVisitSubCount = () => {
    return api.get(`/analysis4HomePage/getAnalysis4HomePage4Visit4ManageUser`);
};
